import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './pages/login/login.component';
import { DealsComponent } from './pages/deals/deals.component';
import { FilesComponent } from './pages/files/files.component';
import { FileDataComponent } from './pages/file-data/file-data.component';
import { CreateDealComponent } from './pages/create-deal/create-deal.component';
import { UploadFilesComponent } from './pages/upload-files/upload-files.component';
import { SubmitDealComponent } from './pages/submit-deal/submit-deal.component';
import { SignupComponent } from './pages/signup/signup.component';
import { FundDataComponent } from './pages/fund-data/fund-data.component';


const routes: Routes = [
	{
		path: '',
		component: LoginComponent
	},
	{
		path: 'signup',
		component: SignupComponent
	},
	{
		path: 'login',
		component: LoginComponent
	},
	{
		path: 'funds',
		component: DealsComponent
	},
	{
		path: 'files',
		component: FilesComponent
	},
	{
		path: 'file-data',
		component: FileDataComponent
	},
	{
		path: 'fund-data',
		component: FundDataComponent
	},
	{
		path: 'create-fund',
		component: CreateDealComponent
	},
	{
		path: 'upload-files',
		component: UploadFilesComponent
	},
	{
		path: 'compile-data',
		component: SubmitDealComponent
	},
	{
		path: 'seine-capital',
		component: LoginComponent
	},
	{
		path: '**',
		component: LoginComponent
	},
];

@NgModule({
	imports: [RouterModule.forRoot(routes, {})],
	exports: [RouterModule]
})

export class AppRoutingModule { }
